export type Shadow = {
  x: number;
  y: number;
  blur: number;
  spread: number;
  color: string;
  inset?: boolean;
};

export const lightShadows = {
  "shadow-button": [
    {
      x: 0,
      y: 1,
      blur: 0,
      spread: 0,
      color: "rgba(0, 0, 0, 0.05)",
    },
  ],
  "shadow-scroll": [
    {
      x: 0,
      y: 0,
      blur: 10,
      spread: 0,
      color: "rgba(0, 0, 0, 0.12)",
    },
    {
      x: 0,
      y: 0,
      blur: 4,
      spread: 0,
      color: "rgba(0, 0, 0, 0.08)",
    },
  ],
  "shadow-modal": [
    {
      x: 0,
      y: 26,
      blur: 80,
      spread: 0,
      color: "rgba(0, 0, 0, 0.2)",
    },
    {
      x: 0,
      y: 0,
      blur: 1,
      spread: 0,
      color: "rgba(0, 0, 0, 0.2)",
    },
  ],
  "shadow-menu": [
    {
      x: 0,
      y: 0,
      blur: 2,
      spread: 0,
      color: "rgba(0, 0, 0, 0.2)",
    },
    {
      x: 0,
      y: 5,
      blur: 10,
      spread: 0,
      color: "rgba(0, 0, 0, 0.08)",
    },
  ],
  "shadow-base": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(63, 63, 68, 0.05)",
    },
    {
      x: 0,
      y: 1,
      blur: 3,
      spread: 0,
      color: "rgba(63, 63, 68, 0.15)",
    },
  ],
  "shadow-card": [
    {
      x: 0,
      y: 0,
      blur: 5,
      spread: 0,
      color: "rgba(23, 24, 24, 0.05)",
    },
    {
      x: 0,
      y: 1,
      blur: 2,
      spread: 0,
      color: "rgba(0, 0, 0, 0.15)",
    },
  ],
  "shadow-popover": [
    {
      x: 0,
      y: 3,
      blur: 6,
      spread: -3,
      color: "rgba(23, 24, 24, 0.08)",
    },
    {
      x: 0,
      y: 8,
      blur: 20,
      spread: -4,
      color: "rgba(23, 24, 24, 0.12)",
    },
  ],
  "shadow-deep": [
    {
      x: 0,
      y: 0,
      blur: 1,
      spread: 0,
      color: "rgba(6, 44, 82, 0.1)",
    },
    {
      x: 0,
      y: 2,
      blur: 16,
      spread: 0,
      color: "rgba(33, 43, 54, 0.08)",
    },
  ],
  "shadow-top-bar": [
    {
      x: 0,
      y: 2,
      blur: 2,
      spread: -1,
      color: "rgba(0, 0, 0, 0.15)",
    },
  ],
  "shadow-select": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(0, 0, 0, 0.05)",
    },
  ],
};

export const darkShadows = {
  "shadow-button": [
    {
      x: 0,
      y: 1,
      blur: 0,
      spread: 0,
      color: "rgba(0, 0, 0, 0.05)",
    },
  ],
  "shadow-scroll": [
    {
      x: 0,
      y: 0,
      blur: 10,
      spread: 0,
      color: "rgba(0, 0, 0, 0.12)",
    },
    {
      x: 0,
      y: 0,
      blur: 4,
      spread: 0,
      color: "rgba(0, 0, 0, 0.08)",
    },
  ],
  "shadow-modal": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(59, 68, 70, 1)",
      inset: true,
    },
  ],
  "shadow-menu": [
    {
      x: 0,
      y: 5,
      blur: 10,
      spread: 0,
      color: "rgba(0, 0, 0, 0.08)",
    },
    {
      x: 0,
      y: 0,
      blur: 2,
      spread: 0,
      color: "rgba(0, 0, 0, 0.2)",
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(59, 68, 70, 1)",
      inset: true,
    },
  ],
  "shadow-base": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(63, 63, 68, 0.05)",
    },
    {
      x: 0,
      y: 1,
      blur: 3,
      spread: 0,
      color: "rgba(63, 63, 68, 0.15)",
    },
  ],
  "shadow-card": [
    {
      x: 0,
      y: 0,
      blur: 5,
      spread: 0,
      color: "rgba(23, 24, 24, 0.05)",
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(147, 180, 187, 0.16)",
      inset: true,
    },
  ],
  "shadow-popover": [
    {
      x: 0,
      y: 8,
      blur: 20,
      spread: -4,
      color: "rgba(23, 24, 24, 0.12)",
    },
    {
      x: 0,
      y: 4,
      blur: 4,
      spread: 0,
      color: "rgba(0, 0, 0, 0.25)",
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(59, 68, 70, 1)",
      inset: true,
    },
  ],
  "shadow-deep": [
    {
      x: 0,
      y: 0,
      blur: 1,
      spread: 0,
      color: "rgba(6, 44, 82, 0.1)",
    },
    {
      x: 0,
      y: 2,
      blur: 16,
      spread: 0,
      color: "rgba(33, 43, 54, 0.08)",
    },
  ],
  "shadow-top-bar": [
    {
      x: 0,
      y: 2,
      blur: 2,
      spread: -1,
      color: "rgba(0, 0, 0, 0.15)",
    },
  ],
  "shadow-select": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(0, 0, 0, 0.05)",
    },
  ],
};

export type CascadiaShadowTypes = typeof lightShadows;
export type CascadiaShadow = keyof CascadiaShadowTypes;
